import "../../Content/Accordion/Accordion";

if (window.innerWidth <= 1023) {
    const iconCalOpen = document.querySelector("#calendar-open");
    const calendarLightbox = document.querySelector(".event-detail-right-content-wrapper");
    const bodyTag = document.querySelector("body");
    const mobileClose = document.querySelector("#mobile-close");
    const description = document.querySelector(".event-description-text");
    let lightboxClosed = true;

    const observer = new window.IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
            iconCalOpen.classList.add('disabled');
            return;
        }
        if (entry.boundingClientRect.top < 0) {
            iconCalOpen.classList.remove('disabled');
        }
    }, {root: null, threshold: 0})

    if (calendarLightbox) {
        observer.observe(calendarLightbox)
    }

    if (iconCalOpen) {
        iconCalOpen.addEventListener('click', function (e) {
            if (lightboxClosed) {
                document.body.style.overflowY = 'hidden';
                bodyTag.classList.add("lock-layer");
                calendarLightbox.classList.add("lightbox");
                mobileClose.childNodes[0].classList.add("active");
                lightboxClosed = false;
            }
        });
    }
    if (mobileClose) {
        mobileClose.addEventListener('click', function () {
            if (!lightboxClosed) {
                bodyTag.classList.remove('lock-layer');
                mobileClose.childNodes[0].classList.remove("active");
                calendarLightbox.classList.remove("lightbox");
                document.body.style.overflowY = 'auto';
                lightboxClosed = true;
            }
        });
    }
    if (bodyTag) {
        document.addEventListener('click', event => {
            if (event.target.classList.contains('lock-layer')) {
                bodyTag.classList.remove('lock-layer');
                mobileClose.childNodes[0].classList.remove("active");
                calendarLightbox.classList.remove("lightbox");
                document.body.style.overflowY = 'auto';
                lightboxClosed = true;
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    const element = document.querySelector('.event-detail-right-content');
    if (typeof (element) != 'undefined' && element != null) {
        let desktopFlag = true;
        let motivationElement = document.querySelector(".event-detail-right-content-wrapper");

        if (window.innerWidth < 1024 && desktopFlag) {
            document.querySelector('.mobile-cal-teaser').append(motivationElement);
            desktopFlag = false;
        }

        window.addEventListener("resize", (event) => {
            if (window.innerWidth < 1024 && desktopFlag) {
                document.querySelector('.mobile-cal-teaser').append(motivationElement);
                desktopFlag = false;
            }
            if (window.innerWidth > 1024 && !desktopFlag) {
                document.querySelector('.mobile-cal-teaser').append(motivationElement);
                desktopFlag = true;
            }
        });

        if(!document.querySelector('h1') && !document.querySelector('.jobs-detail-image') && !document.querySelector('.neos-backend')){
            window.location.href = "404";
        }
    }
})
